module.exports = __webpack_public_path__ + "img/vip.6c85a0d6.png";